import { render, staticRenderFns } from "./TopMenosCuponsCard.vue?vue&type=template&id=33c55291"
import script from "./TopMenosCuponsCard.vue?vue&type=script&lang=js"
export * from "./TopMenosCuponsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports